import { Component, OnInit, OnDestroy } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { Vehicule, Group } from '../../../data-management/data-management.model';
import { DataManagementService } from '../../../data-management/data-management.service';

@Component({
  selector: 'app-toll',
  templateUrl: './toll.component.html',
  styleUrls: ['./toll.component.css']
})
export class TollComponent implements OnInit, OnDestroy {

  selectedVehicule?: Vehicule;
  selectedGroup?: Group;

  getVehiculeWasSelectedSubscription: Subscription = new Subscription();
  getGroupWasSelectedSubscription: Subscription = new Subscription();

  documentType: 'TOLL' = 'TOLL';

  constructor(public toastr: ToastrService, private dataManagementService: DataManagementService) { }

  ngOnInit() {
    if (this.dataManagementService.selectedVehicule && this.dataManagementService.selectedGroup) {
      this.selectedVehicule = this.dataManagementService.selectedVehicule;
      this.selectedGroup = this.dataManagementService.selectedGroup;
    }
    this.getVehiculeWasSelectedSubscription = this.dataManagementService.getVehiculeWasSelected().subscribe(vehicule => {
      this.selectedVehicule = vehicule;
    });
    this.getGroupWasSelectedSubscription = this.dataManagementService.getGroupWasSelected().subscribe(group => {
      this.selectedGroup = group;
    });
  }

  ngOnDestroy() {
    this.getGroupWasSelectedSubscription.unsubscribe();
    this.getVehiculeWasSelectedSubscription.unsubscribe();
  }

}
